import {
  parseTranslations,
  CommonTranslations,
  Login,
  Sites
} from '@pmi/pmi-iqos-shared-react'
import LoginTranslations from './login.json'

Login.componentTranslations = {
  ...LoginTranslations,
  ...CommonTranslations
}

Login.componentDefaultProps = {
  ...Login.componentDefaultProps,
  translations: {
    ...parseTranslations(Login.componentTranslations, true)
  },
  site: Sites.iqosphere
}

Login.onLoginSuccessAdditionalAction = async () => {
  // await api.iqosphereAuth.getPosition(true)
}

export default Login
